// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;
// Load BS
require('bootstrap');

//Load Libraries
require('flatpickr/dist/flatpickr.min');
require('magnific-popup/dist/jquery.magnific-popup.min');
require('objectFitPolyfill/dist/objectFitPolyfill.min');
require('select2/dist/js/select2.full.min');
require('@accessible360/accessible-slick/slick/slick.min');
require('masonry-layout/dist/masonry.pkgd.min');
require('imagesloaded/imagesloaded.pkgd.min');
require('countup.js/dist/countUp.min');

//Load Modules
require('./modules/accordion');
require('./modules/animatein');
require('./modules/bannerVideo');
require('./modules/footerMenu');
require('./modules/formInputs');
require('./modules/localVideoBlock');
require('./modules/menu');
require('./modules/modal');
require('./modules/scrollTo');
require('./modules/shareSocial');
require('./modules/sideMenu');
require('./modules/tabs');
require('./modules/inlineVideo');
require('./modules/showcaseLocalVideoBlock');
require('./modules/gpVideoBlock');
require('./modules/scrollBannerImage');
require('./modules/videoButtonReplacer');
require('./modules/gp2ColVideo');

require('./modules/videoPopup.js');
require('./modules/gravityforms.js');
require('./modules/tooltip.js');

// highlight related label when input in focus
$("form :input").focus(function(){
    $("label[for='" + this.id +"']").addClass("__labelfocus");
}).blur(function(){
    if($(this).val().length < 1){
        $("label[for='" + this.id +"']").removeClass("__labelfocus");
    }
});

